// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1M2Oj","First":"style__First___8Cq7X","FirstInner":"style__FirstInner___1fNCa","FirstInnerOverlay":"style__FirstInnerOverlay___28zhn","FirstInnerOverlayTitle":"style__FirstInnerOverlayTitle___1WSQA","FirstInnerOverlaySubtitle":"style__FirstInnerOverlaySubtitle___pqdQJ"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/carousel/basic/first/style.css
// module id = 1450
// module chunks = 0